// extracted by mini-css-extract-plugin
export var dot = "_qk-2";
export var wave = "_qk-0";
export var waveSmall = "_qk-1";